import { render, staticRenderFns } from "./MyDraftOrders.vue?vue&type=template&id=172e57ef&"
import script from "./MyDraftOrders.vue?vue&type=script&lang=js&"
export * from "./MyDraftOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports